import { View } from "@react-pdf/renderer";
import { styles } from "./styles";
import { TableReport } from "./firstPageComponents/table";
import { GraphViewer } from "./utils/graph";
import { RangeView } from "./firstPageComponents/range";
import { IntroView } from "./firstPageComponents/intro";

export const FirstPage = ({ relatorio, graphcs, sharedOptions, show }) => {
	return (
		<View style={styles.firsPageContainer}>
			<RangeView sharedOptions={sharedOptions} />
			<IntroView relatorio={relatorio} sharedOptions={sharedOptions} />
			<GraphViewer
				graphcs={graphcs?.graphcs}
				sharedOptions={sharedOptions}
				description={`${
					show?.percentile ? `${relatorio?.percentil}th ` : ""
				}percentil do cliente ${relatorio?.client}`}
				font={`Fonte: Dados coletados pelo ${relatorio?.source}`}
			/>
			{!!show && Object.values(show).some(Boolean) && (
				<TableReport relatorio={relatorio} show={show} />
			)}
		</View>
	);
};
